// Angular
import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { InvoiceDetailsFormData } from "@app/dto/InvoiceDetailsFormData";
import ChatVisibilityHelper from "@app/helpers/ChatvisibilityHelper";
import SessionStorage from "@app/helpers/SessionStorage";
import { Country } from "@app/interfaces/Country";
import { LabelValue } from "@app/interfaces/LabelValue";
import { ZiplCodes } from "@app/interfaces/ZipCodes";
import { LoadCsvService } from "@app/services/loadCsv.service";
// 3rdparty
import { MatDialog } from "@angular/material/dialog";
import { ChatDialogComponent } from "@app/dialogs/chat-dialog/chat-dialog.component";
import { ExcludedServicesInformationDialogComponent } from "@app/dialogs/excluded-services-information-dialog/excluded-services-information-dialog.component";
import { GenericMessageDialogComponent } from "@app/dialogs/generic-message-dialog/generic-message-dialog.component";
import { SimpleDataTransferStatementApprovalDialogComponent } from "@app/dialogs/simple-data-transfer-statement-approval-dialog/simple-data-transfer-statement-approval-dialog.component";
import { RoomGuest } from "@app/dto/ReservationInfo";
import { BigFish } from "@app/interfaces/BigFish";
import { GenericMessage } from "@app/interfaces/generic-message";
import { StartBillingResponse } from "@app/interfaces/StartBillingResponse";
import { BillingService } from "@app/services/billing.service";
import { SessionstorageService } from "@app/services/sessionstorage.service";
import { SpinnerService } from "@app/services/spinner.service";
import { ActiveHoursDialogComponent } from "@globalshared/chat/src/lib/dialog/active-hours/active-hours-dialog.component";
import { ChatService } from "@globalshared/chat/src/lib/services/chat.service";
import { TranslateService } from "@ngx-translate/core";
import { AutoUnsubscribe } from "ngx-auto-unsubscribe";
import { Subject, Subscription, catchError, combineLatest, debounceTime, firstValueFrom, forkJoin, takeUntil, throwError } from "rxjs";
import { SubscriberParameter } from "../../../../../froexishared/src/dto/SubscriberParameter";
import { SubscriberParameterService } from "../../../../../froexishared/src/services/SubscriberParameter.service";
import { ReservationService } from "@app/services/reservation.service";
import { InvoiceAddressSelectionDialogComponent } from "@app/dialogs/invoice-address-selection-dialog/invoice-address-selection-dialog.component";
import { FroExoResAddr } from "@app/interfaces/FroExoResAddr";
// Hostware

@Component({
  selector: "invoice-details",
  templateUrl: "./invoice-details.component.html",
  styleUrls: ["./invoice-details.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

@AutoUnsubscribe()
export class InvoiceDetailsComponent implements OnInit, OnDestroy {

  group: FormGroup;
  countries: Country[] = [];
  zipCodes: ZiplCodes[] = [];
  taxableTypes: LabelValue[] = [];
  loadCountries$: Subscription;
  filteredCountry: Country[] = []
  destroy$: Subject<boolean> = new Subject<boolean>();
  startBillingRespose: StartBillingResponse;
  paymentParameters: any;
  allowedPaymentType: string;
  bigFishPaymentParameters: BigFish;
  loaded: boolean
  messageVisible: boolean = false;
  taxNoRequired: boolean = true;

  messageCounterAfterClose: number = 0
  messageCounter: number = 0
  badgeValue: number = 0
  rinf = JSON.parse(sessionStorage.getItem('rinf'))

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private translate: TranslateService,
    private router: Router,
    private loadCsvService: LoadCsvService,
    private subscriberParamaterService: SubscriberParameterService,
    private activatedRoute: ActivatedRoute,
    private billingService: BillingService,
    private spinnerService: SpinnerService,
    private errorDialog: MatDialog,
    private bigFishPaymentDialog: MatDialog,
    private ref: ChangeDetectorRef,
    private szepCardAlertDialog: MatDialog,
    public sessionStorageService: SessionstorageService,
    private chatService: ChatService,
    private dialog: MatDialog,
    private reservationService: ReservationService

  ) {
    this.group = this.fb.group({
      FirstName: new FormControl("", [Validators.required, Validators.maxLength(45)]),
      LastName: new FormControl("", [Validators.required, Validators.maxLength(45)]),
      Address: new FormControl("", [Validators.required]),
      Phone: new FormControl("", [Validators.required, Validators.pattern(/^\d{1,14}$/), Validators.maxLength(14)]),
      PhonePrefix: new FormControl("", [Validators.required, Validators.pattern(/^\d{1,3}$/), Validators.maxLength(3)]),
      Zip: new FormControl("", [Validators.required, Validators.maxLength(16)]),
      City: new FormControl("", [Validators.required, Validators.maxLength(50)]),
      CountryCode: new FormControl("", [Validators.required]), // set default based on MRZ data
      Email: new FormControl("", [
        Validators.email,
        Validators.required,
        Validators.maxLength(254),
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
      ]),
      TaxableEntity: new FormControl("M", [Validators.required]),
      TaxNo: new FormControl(""),
    });
  }

  // startbilling, onlyview = false
  async ngOnInit() {
    this.reservationService.getResAddress(this.rinf.Hotel3pId, this.rinf.ReservationUuId).subscribe((data: FroExoResAddr[]) => {
      // AType: 3 - Előlegszámla
      this.dialog.open(InvoiceAddressSelectionDialogComponent, {
        hasBackdrop: true,
        width: "auto",
        maxWidth: "100",
        data: { items: data }
      }).afterClosed().subscribe((selected: FroExoResAddr) => {
        if (selected) {
          this.fillFormFromAddress(selected)
        }
      })
    })


    this.chatService.customerFacingDataLength.subscribe(data => {
      this.messageCounter = data;

      if (this.messageCounter > this.messageCounterAfterClose) {
        this.badgeValue = this.messageCounter - this.messageCounterAfterClose
      } else {
        this.badgeValue = 0
      }
    })

    // this.translate.getDefaultLang() === 'hu' ? this.loadCsvService.getDataFromCsv('assets/data/hu-countries.csv', ";", this.countries, 'lang') : this.loadCsvService.getDataFromCsv('assets/data/en-countries.csv', ";", this.countries, 'lang');
    // this.filteredCountry = this.countries;

    // this.loadCsvService.getDataFromCsv('assets/data/zip-codes.csv', ";", this.zipCodes, 'zipCode');
    if (this.translate.getDefaultLang() === 'hu') {
      this.countries = await firstValueFrom(this.loadCsvService.getDataFromCsv('/assets/data/hu-countries.csv', ";", 'lang'))
    } else {
      this.countries = await firstValueFrom(this.loadCsvService.getDataFromCsv('/assets/data/en-countries.csv', ";", 'lang'))
    }

    this.filteredCountry = [...this.countries];

    this.zipCodes = await firstValueFrom(this.loadCsvService.getDataFromCsv('assets/data/zip-codes.csv', ";", 'zipCode'));

    this.taxableTypes = [
      {
        Label: this.translate.instant("invoice_details.person"),
        Value: "M",
      },
      {
        Label: this.translate.instant("invoice_details.lpwtaxnum"),
        Value: "J",
      },
      {
        Label: this.translate.instant("invoice_details.domestic_taxpayer"),
        Value: "B",
      },
      {
        Label: this.translate.instant("invoice_details.community_taxpayer"),
        Value: "K",
      },
      {
        Label: this.translate.instant("invoice_details.third_country_taxpayer"),
        Value: "H",
      }
    ];

    combineLatest({
      countryCode: this.group.get('CountryCode').valueChanges,
      postalCode: this.group.get('Zip').valueChanges
    }).pipe(debounceTime(300))
      .subscribe((result) => {
        if (result.countryCode === 'HUN') {
          let filterCity = this.zipCodes.find(zipCode => zipCode.zipCode === result.postalCode).City
          this.group.get('City').setValue(filterCity)
        }
      })
    this.preparePayment()
  }

  openChat() {
    if (this.chatService.isWithin()) {
      let reOpenChat = localStorage.getItem('reOpenChat');
      if (reOpenChat === 'true') {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: true
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
      } else {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: false
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
        // this.dialog.open(YesNoDialogComponent, {
        //   disableClose: true,
        //   hasBackdrop: true,
        //   width: "auto",
        //   data: { messageText: this.translate.instant('chat.start_chat_question'), messageType: 'CHAT', showIcon: true }
        // }).afterClosed().subscribe(data => {
        //   if (data) {
        //     this.dialog.open(ChatDialogComponent, {
        //       minWidth: '100vw',
        //       height: '100dvh',
        //       data: {
        //         isMinimized: false
        //       }
        //     }).afterClosed().subscribe(data => {
        //       this.badgeValue = 0
        //       this.messageCounterAfterClose = data
        //     })
        //   }
        // })
      }
    } else {
      this.dialog.open(ActiveHoursDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: { messageText: this.translate.instant('chat.non-active-session-title'), messageType: 'WARNING', showIcon: true }
      })
    }
  }

  onKeyCountry(event) {
    this.filteredCountry = this.search(event.target.value);
  }

  search(value: string) {
    let filter = value.toLowerCase()
    return this.countries.filter(country => country.Name.toLocaleLowerCase().startsWith(filter));
  }

  navigateBack() {
    this.router.navigateByUrl("/balance");
  }

  fillFormFromAddress(item: FroExoResAddr) {
    const [firstNamePart, ...restNameParts] = (item.CustomerName || "").split(" ")
    const country = this.countries.find(c => c.Id === item.Country)

    this.group.patchValue({
      FirstName: restNameParts.join(" "),
      LastName: firstNamePart || "",
      Address: item.Street,
      Zip: item.ZipCode,
      City: item.City,
      CountryCode: country?.Id3 || "",
      Email: item.Email,
      TaxableEntity: item.VatOrigin,
      TaxNo: item.TaxNumber,
    })
    this.prepareTaxNoField(item.VatOrigin)
  }

  prepareTaxNoField(vatOrigin: string) {

    //érvényes adószám példa 10426917-2-42 
    this.group.controls["TaxNo"].clearValidators();
    switch (vatOrigin) {
      case VAT_ORIGINS.BELFOLDI_ADOAALANY:
        this.group.controls["TaxNo"].setValidators([Validators.required, adoszamValidator()])
        this.group.controls["TaxNo"].updateValueAndValidity()
        this.taxNoRequired = true;
        break;
      case VAT_ORIGINS.KOZOSSEGI_ADOALANY:
      case VAT_ORIGINS.HARMADIK_ORSZAGBELI_ADOALANY:
      case VAT_ORIGINS.ADOSZAM_NELKULI_JOGI_SZEMELY:
      case VAT_ORIGINS.MAGANSZEMELY:
        this.group.controls["TaxNo"].clearValidators()
        this.group.controls["TaxNo"].updateValueAndValidity()
        this.taxNoRequired = false;
        break;
    }
    this.group.updateValueAndValidity()
  }

  taxNoFieldVisibleStyle() {
    let styles = {};
    if (this.group.controls["TaxableEntity"].value == "M" || this.group.controls["TaxableEntity"].value == "J") {
      styles["visibility"] = "hidden"
      styles["position"] = "absolute"
    } else {
      styles["visibility"] = "visible"
    }
    return styles
  }
  preparePayment() {
    // store local data
    let formData = this.group.value;
    let originalFormData = formData as InvoiceDetailsFormData;

    SessionStorage.InvoiceDetails = originalFormData
    const selectedGuest = JSON.parse(sessionStorage.getItem('sgd')) as RoomGuest
    const combinedSources = forkJoin({
      startbillingResponse: this.billingService.StartBilling(selectedGuest.GuestStayUuId, SessionStorage.ActiveLanguage, true).pipe(
        catchError(err => {
          err.source = 'startbilling'
          return throwError(() => err)
        })
      ),
      allParameters: this.subscriberParamaterService.loadAll(SessionStorage.ReservationInfo.Subscriber,
        parseInt(SessionStorage.ReservationInfo.Hotelid)),
    }).pipe(takeUntil(this.destroy$)).subscribe({
      next: (values) => {
        this.startBillingRespose = values.startbillingResponse as StartBillingResponse;

        const paymentParam = (values.allParameters as SubscriberParameter[]).find(item => item.Param_Typecode == "PAYMENT_PARAMETERS");
        this.paymentParameters = JSON.parse(paymentParam.Param_Json_Value)

        const paymentType = (values.allParameters as SubscriberParameter[]).find(item => item.Param_Typecode == "PAYMENT_TYPE");
        this.allowedPaymentType = paymentType.Param_String_Value


        switch (this.allowedPaymentType) {
          case "SIMPLE":
            //this.processSimplePayment();
            break;
          case "BIGFISH":
            this.bigFishPaymentParameters = JSON.parse(paymentParam.Param_Json_Value)["BIGFISH"] as BigFish
            break;
        }

        this.loaded = true
        this.ref.detectChanges();
        this.spinnerService.setSpinnerVisibility(false);
      },
      error: (err) => {
        this.spinnerService.setSpinnerVisibility(false);
        if (err.source == 'startbilling') {
          const reason = err.error.toString().trim();
          let messageText: string;
          switch (reason) {
            case "INVALID_HOTEL3PID":
              messageText = this.translate.instant('startbilling.invalid_hotel3pid');
              break;
            case "INVOICING_IN_PROGRESS":
              messageText = this.translate.instant('startbilling.invoicing_in_progress');
              break;
            case "INVOICING_LOCKED_BY_FRO":
              messageText = this.translate.instant('startbilling.invoicing_locked_by_fro');
              break;
            case "DIFFERENCE_IN_DEPOSIT":
              messageText = this.translate.instant('startbilling.difference_in_deposit');
              break;
            case "PROCESS_ERROR":
              messageText = this.translate.instant('startbilling.process_error');
              break;
            default: {
              messageText = this.translate.instant('common.network_error')
              break
            }
          }
          let messageData: GenericMessage = { messageText: messageText, messageType: 'ERROR', showIcon: true }
          const dialogRef = this.errorDialog.open(GenericMessageDialogComponent, {
            disableClose: true,
            hasBackdrop: true,
            width: "auto",
            data: messageData
          })
          dialogRef.afterClosed().subscribe(res => {
            this.spinnerService.setSpinnerVisibility(false);
            //this.headerService.setNavigationVisibility(true);
            this.router.navigateByUrl('balance')
          })
        }
      }
    })
  }


  ngOnDestroy(): void {
    this.loadCountries$?.unsubscribe();
  }

  chatIconStyle() {
    let styles = {};
    styles = ChatVisibilityHelper.ChatVisibleStyle
    return styles
  }

  forward() {
    let formData = this.group.value;
    let originalFormData = formData as InvoiceDetailsFormData;
    originalFormData.Country = this.countries.find(item => item.Id3 == originalFormData.CountryCode).Id;
    originalFormData.CountryCode = this.countries.find(item => item.Id3 == originalFormData.CountryCode).Id;

    SessionStorage.InvoiceDetails = originalFormData
    if (SessionStorage.SelectedPaymentType == "SZEPCARD") {
      if (SessionStorage.HasExludedService === 'y') {
        this.messageVisible = true
        this.szepCardAlertDialog.open(ExcludedServicesInformationDialogComponent).afterClosed().subscribe(result => {
          const isContinue = result ? true : false
          if (isContinue) {
            //SessionStorage.InvoiceDetails = originalFormData
            this.router.navigateByUrl('/billview')
          } else {
            this.router.navigateByUrl('/welcome')
          }
        })
      } else {
        //SessionStorage.InvoiceDetails = originalFormData
        this.router.navigateByUrl('/billview')
      }
    } else {
      // ha otpsimple akkor elfogadó dialógus
      if (SessionStorage.SelectedPaymentMode.includes("SIMPLE", 0)) {
        this.dialog.open(SimpleDataTransferStatementApprovalDialogComponent, {
          disableClose: true,
          hasBackdrop: true,
          maxWidth: '90vw',
          maxHeight: '90vh',
          height: '90%',
          width: '90%',
        }).afterClosed().subscribe(result => {
          if (result) {
            this.router.navigateByUrl('/billview')
          }
        })
      } else {
        this.router.navigateByUrl('/billview')
      }
      //SessionStorage.InvoiceDetails = originalFormData

    }
  }

  currency() {
    return SessionStorage.Currency
  }
}

export function adoszamValidator(): ValidatorFn {
  //10426917-2-42 
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value.toString() === '') {
      return { invalidAdoszam: true };
    }
    var pattern = /^(\d{7})(\d)\-([1-5])\-(0[2-9]|[13][0-9]|2[02-9]|4[0-4]|51)$/;
    var matches = control.value.match(pattern);
    if (matches) {
      // Szorzók az adószám törzsszám része (első 8 jegy) ellenőrző számjegyének
      // meghatározásához (a 8. jegy az első hét jegy alapján). Az adott szorzóval, a
      // törzsszám megfelelő számjegyét (elölről indulva) megszorozzuk, majd ezen
      // szorzatok összegét képezzük.
      var mul = [9, 7, 3, 1, 9, 7, 3];
      // Az adószám törzsszám részének első 7 jegye.
      var base = matches[1].split("");
      // Ellenőrző számjegy (az adószám 8. jegye).
      var check = parseInt(matches[2]);
      // Ellenőrző összeg meghatározása.
      var sum = 0;
      for (var i = 0; i < 7; i++) { sum += parseInt(base[i]) * mul[i]; }
      // Az ellenőrző összeg utolsó jegyének meghatározása (= 10-zel való osztás maradéka).
      var last = sum % 10;
      // Ha a kiszámított ellenőrző számjegy nem nulla, akkor 10-ből kivonjuk.
      if (last > 0) { last = 10 - last; }
      // A kiszámított és kapott ellenőrző számjegyek egyezősége alapján
      // lesz helyes vagy helytelen az adószám.
      if (last === check) {
        return null;
      } else {
        return { invalidAdoszam: true };
      }

    } else {
      return { invalidAdoszam: true };
    }
  }
}


enum VAT_ORIGINS {
  "MAGANSZEMELY" = "M",
  "ADOSZAM_NELKULI_JOGI_SZEMELY" = "J",
  "BELFOLDI_ADOAALANY" = "B",
  "KOZOSSEGI_ADOALANY" = "K",
  "HARMADIK_ORSZAGBELI_ADOALANY" = "H"
}
